<script setup lang="ts">
import { AppStandardModal } from '@libs/ui';

import type { HotelAmenityData } from '../../../../core/models';
import HotelAmenities from '../description/HotelAmenities.vue';

interface AmenitiesModalProps {
  amenitiesGroups: HotelAmenityData[][];
}

const props = defineProps<AmenitiesModalProps>();

interface AmenitiesModalEmits {
  (eventName: 'close'): void;
}

const emit = defineEmits<AmenitiesModalEmits>();
</script>

<template>
  <AppStandardModal @close="emit('close')">
    <template #title>
      {{ $t('filter.amenities.description') }}
    </template>
    <template #body>
      <HotelAmenities :amenities-groups="props.amenitiesGroups" />
    </template>
  </AppStandardModal>
</template>
